<template>
  <div class="split-icon float-left">
    <a
      class="home-split d-block"
      href="#"
      @click.prevent="setFavouriteModeLocal(!favouriteMode)"
    >
      <transition name="fade-full" mode="out-in">
        <img
          :src="favouriteActiveIcon"
          class="month-view-cal"
          v-if="favouriteMode"
          key="1"
        />
        <img :src="favouriteIcon" class="month-view-cal" v-else key="2" />
      </transition>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      favouriteIcon: require("../../assets/img/m_favorites.png"),
      favouriteActiveIcon: require("../../assets/img/m_favorites-active.png")
    };
  },
  computed: {
    ...mapGetters("favourites", {
      favouriteMode: "getFavouriteMode"
    })
  },
  methods: {
    ...mapMutations("favourites", {
      setFavouriteMode: "setFavouriteMode"
    }),
    setFavouriteModeLocal(value) {
      this.setToAddPersonMode();
      this.setFavouriteMode(value);
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
    ...mapActions("person", {
      setToAddPersonMode: "setToAddPersonMode" // Search value in the search bar
    })
  },
  beforeDestroy() {
    this.setFavouriteMode(false);
  }
};
</script>

<style scoped>
img {
  max-width: 27px;
}

.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.1s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}
</style>
